/*global _ */
// import settings from '../lib/settings'
export default {
  settings: null,
  props: {
    designerSettings: {}
  },
  beforeCreate() {
    let settings = null
    const propSettings = _.get(this.$options.propsData || {}, 'settings')
    if (propSettings) {
      settings = propSettings
    } else {
      settings = this.$options && this.$options.settings
    }
    if (!settings) {
      settings = this.$parent && this.$parent.settings
    }
    const designerPropSettings = _.get(this.$options.propsData || {}, 'designerSettings', {})
    this.$$setSettings(settings, null, designerPropSettings || {})
  },
  computed: {
    $$$s() {
      return this.$$s()
    }
  },
  methods: {
    $$s(path, defaultValue, ...rest) {
      return this.$options.$$s(path, defaultValue, ...rest)
    },
  }
}
